// extracted by mini-css-extract-plugin
export var quantityInput = "_ot-0";